import { InterviewStatus } from '@recruitai/shared';

interface InterviewStatusTrackerProps {
  status: InterviewStatus;
  mode: 'text' | 'audio';
}

const STEPS_AUDIO = [
  { key: 'upload', label: 'Upload', icon: '📤' },
  { key: 'transcribing', label: 'Transcrição', icon: '📝' },
  { key: 'scoring', label: 'Análise', icon: '🤖' },
  { key: 'done', label: 'Concluído', icon: '✅' },
];

const STEPS_TEXT = [
  { key: 'pending', label: 'Respostas', icon: '📝' },
  { key: 'scoring', label: 'Análise', icon: '🤖' },
  { key: 'done', label: 'Concluído', icon: '✅' },
];

function getStepIndex(status: InterviewStatus, mode: string): number {
  if (mode === 'audio') {
    const map: Record<string, number> = { pending: 0, transcribing: 1, scoring: 2, done: 3 };
    return map[status] ?? 0;
  }
  const map: Record<string, number> = { pending: 0, scoring: 1, done: 2 };
  return map[status] ?? 0;
}

export function InterviewStatusTracker({ status, mode }: InterviewStatusTrackerProps) {
  const steps = mode === 'audio' ? STEPS_AUDIO : STEPS_TEXT;
  const currentIndex = getStepIndex(status, mode);

  return (
    <div className="flex items-center justify-between py-4">
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={step.key} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${
                  isCompleted
                    ? 'bg-green-100'
                    : isCurrent
                    ? 'bg-blue-100 animate-pulse'
                    : 'bg-gray-100'
                }`}
              >
                {step.icon}
              </div>
              <span
                className={`text-xs mt-1 ${
                  isCompleted ? 'text-green-700 font-medium' : isCurrent ? 'text-blue-700 font-medium' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-2 ${isCompleted ? 'bg-green-300' : 'bg-gray-200'}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
